import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "@src/packages/api/louise-api";
import { throwApiError } from "@src/packages/api/api-error";
import type { AcceptedTreatmentPlan } from "../treatmentPlanTypes";

export type { AcceptedTreatmentPlan } from "../treatmentPlanTypes";

export function treatmentPlanQueryKey(patientId: string | null) {
  return ["accepted-treatment-plan", patientId] as const;
}

export function useTreatmentPlan() {
  const { client, patientId } = useApiClient();
  const queryKey = treatmentPlanQueryKey(patientId);

  return useQuery<AcceptedTreatmentPlan | null>({
    queryKey,
    queryFn: async () => {
      if (!patientId) return null;
      const { data, error, response } = await client.GET(
        "/patients/{patientId}/treatment-plan",
        { params: { path: { patientId } } },
      );
      if (error) {
        throwApiError(
          error,
          "Failed to load the accepted treatment plan",
          "useTreatmentPlan",
          response?.status,
        );
      }
      return data?.data ?? null;
    },
    enabled: !!patientId,
  });
}
